import { useFeatureValue } from '@growthbook/growthbook-react'
import classnames from 'classnames'

import { useRecentlyViewedBannerQuery } from '../../../generated/frontend'
import type { RecentlyViewedItem } from './components/RecentlyViewedTextList/RecentlyViewedTextList'
import { RecentlyViewedTextList } from './components/RecentlyViewedTextList/RecentlyViewedTextList'
import styles from './RecentlyViewedBanner.module.scss'

interface RecentlyViewedProps {
  recentlyViewedItems: RecentlyViewedItem[]
}

export const RecentlyViewed = ({ recentlyViewedItems }: RecentlyViewedProps) => {
  const showRecentlyViewedMobile = useFeatureValue('dsp-829-puwylo-mobile-experiment', false)

  return (
    <div className={classnames({ [styles.hideWhenNarrow]: !showRecentlyViewedMobile })}>
      <RecentlyViewedTextList items={recentlyViewedItems} />
    </div>
  )
}

export const RecentlyViewedBanner = () => {
  const { data, loading, error } = useRecentlyViewedBannerQuery()

  if (loading || error) {
    return null
  }

  const recentlyViewedItems = data?.signupCompletePage?.recentlyViewed?.content ?? []
  if (recentlyViewedItems.length === 0) {
    return null
  }

  return <RecentlyViewed recentlyViewedItems={recentlyViewedItems} />
}
